import StreamSymbol from 'enums/StreamSymbol'
import { PostMetric } from 'schemas/PostMetricSchema'

export const isDeletedPost = (postMetric: PostMetric): boolean => !!postMetric.deleted

export const isVocPost = (postMetric: PostMetric): boolean =>
  postMetric.dataStreams?.[0] === StreamSymbol.VOC

export const isPodcastPost = (postMetric: PostMetric): boolean =>
  postMetric.dataStreams?.[0] === StreamSymbol.PODCAST
